// Legacy ecforce freezetech.js の #user_review 仕様を移植 (jQuery → vanilla)。
// 元コード (要約):
//   var urNum = $('#user_review ul li').length;
//   var moreNum = 3;
//   $('#user_review ul li:nth-child(n + 4)').addClass('is-hidden');
//   if (urNum <= moreNum) {
//     $('#user_review .more').fadeOut(0, function(){ $(this).addClass('is-hidden'); });
//   }
//   $('#user_review .more').on('click', function() {
//     $('#user_review ul li.is-hidden').slice(0, moreNum).removeClass('is-hidden');
//     if ($('#user_review ul li.is-hidden').length == 0) {
//       $('#user_review .more').fadeOut(100, function(){ $(this).addClass('is-hidden'); });
//     }
//   });
// CSS 側 (component-ec-force.css) で `.is-hidden { display: none }` を定義済み。
// 100ms fade は CSS の `transition: opacity` で再現する余地はあるが、is-hidden 即時で
// 機能差は出ないので vanilla はクラス付与のみで実装する。
//
// Legacy からの乖離 (#230 Gemini R1/R2/R3):
//   - 最初の `<ul>` の直下 `<li>` だけ対象に → 入れ子 ul の li 誤カウント排除 (R1)
//   - `:nth-child(n+4)` 再検索を index 比較ループに → DOM クエリ回数最小化 (R1)
//   - JS クエリを `.product-rte` / `.article-content` 配下にスコープ → 想定外場所の
//     同 ID 巻き込み防止 (R2)
//   - `dataset.userReviewInited` で二重初期化を防止 → bootstrap が複数回呼ばれた場合
//     の重複イベントリスナー登録を回避 (R3)
//   - `<ul>` 不在で `.more` だけある場合もボタンを非表示にする → レビュー 0 件の状態
//     でも legacy の `urNum <= 3` 分岐と整合 (R3)
//   - 単一 `<ul>` だけでなく top-level `<ul>` 全てを flat 走査 → 並列複数 ul 構造でも
//     正しくカウント・初期非表示が効く。入れ子 ul (li 配下) は除外 (R3)
//
// ID `#user_review` は legacy ec-force HTML が descriptionHtml に直書きしている既存 ID で、
// 全商品の説明文を一括書き換えるのは blast radius が大きいため当面そのまま使う。
(function () {
  const MORE_NUM = 3;
  const INIT_FLAG = 'userReviewInited';

  // reviewRoot 配下の "top-level" <ul> を返す。入れ子 (= ancestor に <li> がある) は
  // レビュー本文中の引用リスト等とみなして除外する。
  function findTopLevelUls(reviewRoot) {
    return Array.from(reviewRoot.querySelectorAll('ul')).filter((ul) => {
      let p = ul.parentElement;
      while (p && p !== reviewRoot) {
        if (p.tagName === 'LI') return false;
        p = p.parentElement;
      }
      return true;
    });
  }

  function init(reviewRoot) {
    // R3: 二重初期化防止 (bootstrap が複数回発火しても重複登録しない)
    if (reviewRoot.dataset[INIT_FLAG]) return;
    reviewRoot.dataset[INIT_FLAG] = 'true';

    const moreBtn = reviewRoot.querySelector('.more');

    // R3: ul 不在時もレビュー 0 件と同等扱いでボタンを非表示にする
    const uls = findTopLevelUls(reviewRoot);
    if (uls.length === 0) {
      if (moreBtn) moreBtn.classList.add('is-hidden');
      return;
    }

    // legacy: $('#user_review ul li') の挙動を「top-level ul の直下 li を flat に集める」
    // で再現。入れ子 ul (li > ul) の li は除外 (上の findTopLevelUls で親側を弾く)。
    const allLis = uls.flatMap((ul) =>
      Array.from(ul.children).filter((el) => el.tagName === 'LI')
    );
    const urNum = allLis.length;

    // legacy: $('#user_review ul li:nth-child(n + 4)').addClass('is-hidden')
    // 複数 ul があっても flat index 基準で 4 件目以降を初期非表示。
    allLis.forEach((el, i) => {
      if (i >= MORE_NUM) el.classList.add('is-hidden');
    });

    // legacy: if(urNum <= moreNum) { $('.more').fadeOut(0, addClass is-hidden) }
    if (urNum <= MORE_NUM) {
      if (moreBtn) moreBtn.classList.add('is-hidden');
    }

    if (!moreBtn) return;

    // legacy: $('#user_review .more').on('click', ...)
    moreBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const hidden = allLis.filter((li) => li.classList.contains('is-hidden'));
      // legacy: .slice(0, moreNum).removeClass('is-hidden')
      const limit = Math.min(MORE_NUM, hidden.length);
      for (let i = 0; i < limit; i++) {
        hidden[i].classList.remove('is-hidden');
      }
      // hidden 取得時点 (= 解除前) の件数で「今回で is-hidden を全部解除した」を判定。
      if (hidden.length <= MORE_NUM) {
        moreBtn.classList.add('is-hidden');
      }
    });
  }

  function bootstrap() {
    // legacy: if($("#user_review").length >= 1)
    // ec-force 由来の #user_review は商品 RTE と記事本文の中だけで使われる。サイト全体
    // をなめると別所で同 ID が紛れていた場合に巻き込み事故を起こすので、親 class で
    // スコープしておく (#230 Gemini R2)。
    document
      .querySelectorAll('.product-rte #user_review, .article-content #user_review')
      .forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
